// `${ERROR_MSG} loading your wallet.`
export const ERROR_MSG = 'Oops, there was an issue';
export const GENERIC_ERROR_MSG = 'Something unexpected happened.';
export const WALLET_WINDOW_LOADING_MSG =
  'Please sign the transaction in your wallet that opened in a new window. If disconnected, try again or cancel.';
